<template>
  <with-loader use-as-overlay
               id="template-selector"
               :loading="isBlockBeingAdded"
  >

    <div class="flex pb-5 border-solid border-b border-0 border-soft">
      <span class="my-auto py-1 ml-6">
      <base-button variant="transparent-primary"
                   icon="keyboard_arrow_left"
                   @click="hideTemplateSelector"
      />
      </span>

      <span class="my-auto px-4 ml-4 border-solid border-l-2 border-0 border-soft text-gray-dark">
        Choose a block or
        <router-link :to="`/bots/${botId}/blocks/new`" class="hover:underline">
          create a new one
        </router-link>
      </span>
    </div>

    <vs-list class="mt-5 pb-24">
      <vs-list-item v-for="template in templateList"
                    :key="template.id"
                    class="p-5 border-0"
                    :title="template.name"
      >
        <base-button variant="bordered"
                     class="w-24"
                     @click="useTemplate(template)"
        >
          Use
        </base-button>
      </vs-list-item>
    </vs-list>

  </with-loader>
</template>

<script>
import previewModule from '@/store/modules/preview.module'
import templateModule from '@/store/modules/template.module'
import templateSelectorModule from '@/store/modules/template-selector.module'
import conversationModule from '@/store/modules/conversation.module'
import chatBubbleModule from '@/store/modules/chat-bubble.module'
import answerController from '@/controllers/answer.controller'
import templateService from '@/services/amio/template.service'
import clone from 'ramda/src/clone'
import { CONVERSATION_TYPES } from '@/store/constants'
import { STATE_ID } from '@/utils/bot-json.constants'
import busyButtonsModule from '@/store/modules/busy-buttons.module'
import { BUSY_BUTTONS } from '@/utils/busy-buttons.constants'
import BusyButton from '@/components/common/BusyButton.vue'
import WithLoader from '@/components/common/WithLoader.vue'
import toaster from '@/utils/toaster'
import stateTreeUtils from '@/utils/state-tree.utils'

export default {
  name: 'TemplateSelector',

  components: {
    WithLoader,
    BusyButton
  },

  props: {
    botId: {
      type: String,
      required: true
    },
    stateId: {
      type: String,
      required: true
    },
    isInsideCondition: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      addBlockButtonId: BUSY_BUTTONS.BLOCK_ADD
    }
  },

  computed: {
    error: previewModule.error,
    templateList: templateModule.templateList,
    bubbleSelected: chatBubbleModule.bubbleSelected,
    stateTree: chatBubbleModule.stateTree,

    isBlockBeingAdded() {
      return busyButtonsModule.isButtonBusy(this.addBlockButtonId)
    }
  },

  methods: {
    hideTemplateSelector() {
      templateSelectorModule.hideSelector()
    },

    async useTemplate(selectedTemplate) {
      if (this.isBlockBeingAdded) return

      busyButtonsModule.setButtonBusy(this.addBlockButtonId, true)
      const isAddingToEmptyPostback = previewModule.isAddingToEmptyPostback(this.bubbleSelected)
      try {
        const template = await templateService.get(this.botId, selectedTemplate.id)
        const templateRefStateId = answerController.useTemplate(
          clone(conversationModule.getRootJson()),
          answerController.getTransitionsStateId(this.stateId, this.isInsideCondition),
          template,
          stateTreeUtils.findNode(this.stateTree, this.bubbleSelected)
        )

        if (conversationModule.isConditionState(STATE_ID.ROOT, CONVERSATION_TYPES.TEMPLATES, template.id)) {
          chatBubbleModule.selectConditionSection(STATE_ID.ROOT, 0, true)
        } else {
          const templateActionId = template.conversationJson.states.root.actions[0]
          const templateActionType = template.conversationJson.actions[templateActionId].type
          chatBubbleModule.selectBubbleByActionType(templateActionType, templateRefStateId, templateActionId)
        }
        this.hideTemplateSelector()
        if (isAddingToEmptyPostback) this.error = null
      } catch (err) {
        toaster.error(err.message, err)
      } finally {
        busyButtonsModule.setButtonBusy(this.addBlockButtonId, false)
      }
    }
  },

  async created() {
    const templates = await templateService.list(this.botId)
    templateModule.setTemplateList(templates)
  },

  destroyed() {
    this.hideTemplateSelector()
  }
}
</script>
